import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { ContractInfoCard } from '../../components/contract-info-card.component';
import { YourContractsSection } from '../../components/your-contracts-section.component';
import { CustomerContractsGrid } from '../../components/customer-contracts-grid.component';
import { CustomerOffersGrid } from '../../components/customer-offers-grid.component';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchEmploymentContracts } from '../../features/employment-contract/employment-contract.slice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../scss/my-contracts.page.scss';

const ContractTabIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M6 2h9l5 5v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M15 2v5h5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

const OfferTabIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M20 19.5v.5a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h7.5L20 8.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18.42 9.61a2.1 2.1 0 1 1 2.97 2.97L16.95 17 13 18l.99-3.95z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

function MyContractsPage() {
    const { t } = useTranslation();
    const language = new URLSearchParams(window.location.search).get('lang') || 'en';
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [searchParams] = useSearchParams();
    const [activeGridTab, setActiveGridTab] = useState<'contracts' | 'offers'>(
        searchParams.get('tab') === 'offers' ? 'offers' : 'contracts'
    );
    const dispatch = useDispatch<any>();
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(fetchEmploymentContracts());
    }, [dispatch]);
    function handleTenderAgreement() {
        navigate(`/v2/create-offer?lang=${language === 'sv-se' ? 'sv-se' : 'en-us'}`)
    }
        function handleContractAgreement() {
        if (language === 'sv-se') {
            navigate('/v2/create-contract?lang=sv-se')
        }
        else {
            navigate('/v2/create-contract?lang=en-us')
        }
    }


    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='contracts'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content mc-contracts-page">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />

                    <div className='px-3'>
                        <div style={{ marginTop: '24px' }}>
                            <div>
                                <ContractInfoCard />
                            </div>

                            <section className="mc-tender-section" style={{ marginTop: '24px' }}>
                                <YourContractsSection variant="tender" handleTenderAgreement={handleTenderAgreement} handleContractAgreement={handleContractAgreement} />
                            </section>

                            <section className="mc-contract-suite" style={{ marginTop: '24px' }}>
                                <YourContractsSection variant="customer" handleTenderAgreement={handleTenderAgreement} handleContractAgreement={handleContractAgreement} />

                                <div className="mc-grid-tabs" role="tablist" aria-label={t('CONTRACTS_AND_AGREEMENTS') as string}>
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={activeGridTab === 'contracts'}
                                        className={`mc-grid-tabs__tab${activeGridTab === 'contracts' ? ' is-active' : ''}`}
                                        onClick={() => setActiveGridTab('contracts')}
                                    >
                                        <ContractTabIcon />
                                        <span>{t('CCG_TITLE')}</span>
                                    </button>
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={activeGridTab === 'offers'}
                                        className={`mc-grid-tabs__tab${activeGridTab === 'offers' ? ' is-active' : ''}`}
                                        onClick={() => setActiveGridTab('offers')}
                                    >
                                        <OfferTabIcon />
                                        <span>{t('COG_TITLE')}</span>
                                    </button>
                                </div>

                                {activeGridTab === 'contracts' ? <CustomerContractsGrid /> : <CustomerOffersGrid />}
                            </section>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default MyContractsPage;

